import {FilterEntity} from './filter-entity';
import {environment} from '../../../environments/environment';

export class FindEntity {
  constructor(
    public entity?: string,
    public filters?: FilterEntity[],
    public idSite: number = 0,
    public idWindow: number = 0,
    public idHabilitation?: number,
    public page: number = 0,
    public size: number = environment.defaultListSize,
    public predicats?: Sort[]
  ) {}
}

export class Sort {
  constructor(
    public column: string,
    public sens: string
  ) {}
}
